module.exports = __webpack_public_path__ + "static/img/m110bb.f2d1de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/m110bb.jpg
// module id = ssNJ
// module chunks = 0